import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { ChangeDetectorRef, Component } from '@angular/core';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { MomentDatePipe } from '@mitsubishi/shared/ui';

import { PriceListPublishLevelComponent } from '../price-list-publish-level/price-list-publish-level.component';

interface PriceListCellRendererParams extends ICellRendererParams {
  dataAtRootLevel: boolean;
}

@Component({
  selector: 'apm-price-detail-list-cell',
  imports: [PriceListPublishLevelComponent, MomentDatePipe, ApmTranslatePipe],
  templateUrl: './price-list-details-cell.component.html',
})
export class PriceListDetailsCellComponent implements ICellRendererAngularComp {
  row: any;
  dataAtRootLevel = false;

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: PriceListCellRendererParams) {
    this.setData(params);
  }

  refresh(params: PriceListCellRendererParams): boolean {
    this.setData(params);

    return true;
  }

  private setData(params: PriceListCellRendererParams) {
    const rowData = params.node.data;
    const colId = params.column?.getColId();
    this.dataAtRootLevel = params.dataAtRootLevel;

    if (rowData && this.dataAtRootLevel) {
      this.row = rowData;
    } else if (rowData && colId) {
      this.row = rowData[colId];
    }
    this.cdr.detectChanges();
  }
}
